import * as BlockComponentsLocal from "../blocks"


type modesType = "view" | "edit"

type BlockComponentsType = {
  [key: string]: {
    [key in modesType]: React.ComponentType<any>
  }
}

export const getBlockTypeKey = (type: string) => {
  // return the proper key for a block
  return Object.keys(BlockComponentsLocal).find(
    (k) => k.toLowerCase() === type.toLowerCase()
  )
}

export const getBlock = (type: string, mode?: string) => {
  const typeName = getBlockTypeKey(type)
  const BlockComponents= BlockComponentsLocal as BlockComponentsType

  if (!typeName || !BlockComponents[typeName])
    throw new Error(
      `No block type ${typeName} found. Are you sure you exported it from ./blocks/index?`
    )

  const modes = BlockComponents[typeName]

  if (!modes[mode?.toLowerCase() as modesType]) {
    throw new Error(
      `No block mode ${mode} found for block type ${typeName}. Are you sure you exported it from ./blocks/index?`
    )
  }

  return modes[mode?.toLowerCase() as modesType]
}
